import React, {useState} from 'react';
import * as yup from 'yup';
import {FormProvider, useForm} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers/yup';
import {Card, CardBody, Form, Col, Row} from 'reactstrap';
import {Block, BlockHead, BlockHeadContent, BlockTitle} from '../../../../components/block/Block';
import Button from '../../../../components/button/Button';
import Icon from '../../../../components/icon/Icon';
import {useNavigate} from 'react-router-dom';
import UserForm from './UserForm';
import {IUserData} from '../../../../shared/interfaces/User';
import {phoneRegExp} from '../../../../shared/Regexs';
import {userApi} from '../../../../api';
import {useTranslation} from 'react-i18next';

export const userSchema = yup
  .object({
    contact: yup.object({
      country: yup.string().required('No country provided'),
      phone: yup.string().matches(phoneRegExp, 'Phone number is not valid'),
    }),
    firstName: yup.string().required('No first name provided.').min(2, 'First name is too short - should be 2 chars minimum.'),
    email: yup.string().email().required('No email provided.'),
    roles: yup.array().min(1, 'Select on of roles').required('No roles provided.'),
    password: yup
      .string()
      .required('No password provided.')
      .min(8, 'Password is too short - should be 8 chars minimum.')
      .matches(/[a-zA-Z]/, 'Password can only contain Latin letters.'),
  })
  .required();
const UserCreate = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const [passState, setPassState] = useState(false);
  const formData = new FormData();

  const methods = useForm<IUserData>({
    resolver: yupResolver(userSchema),
  });
  const onFormSubmit = async (state: IUserData) => {
    !!state.file && formData.append('picture', state.file[0]);
    formData.append('body', JSON.stringify(state));
    const {data} = await userApi.createUser(formData);
    if (data) {
      navigate('/app/admin/users');
    }
  };
  return (
    <Block size="lg" className="mt-3">
      <BlockHead>
        <BlockHeadContent>
          <div className="row align-items-center gx-0 gx-lg-2 justify-content-between">
            <div className="col-md-10 col-12">
              <BlockTitle tag="h4">{t('administrator.users.userList')}</BlockTitle>
            </div>
            <div className="col-md-2 col-12 text-end">
              <Button
                className="btn-block"
                color="secondary"
                onClick={() => {
                  navigate(-1);
                }}
              >
                <Icon name="arrow-long-left" />
                {t('general.back')}
              </Button>
            </div>
          </div>
        </BlockHeadContent>
      </BlockHead>
      <Card className="card-bordered card-preview">
        <CardBody>
          <FormProvider {...methods}>
            <Form onSubmit={methods.handleSubmit(onFormSubmit)} className="py-3">
              <UserForm
                passState={passState}
                formState={methods.formState}
                setPassState={setPassState}
                register={methods.register}
                errors={methods.formState.errors}
                isAdmin
              />
              <Row>
                <Col>
                  <Row>
                    <Col className={'text-end'}>
                      <Button color="primary">
                        <Icon name="plus-sm" />
                        {t('general.create')}
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
          </FormProvider>
        </CardBody>
      </Card>
    </Block>
  );
};

export default UserCreate;
